__turbopack_context__.v({
  "categoryEnableAllButton": "preferencesModal-module-scss-module__lz7M4G__categoryEnableAllButton",
  "categoryNav": "preferencesModal-module-scss-module__lz7M4G__categoryNav",
  "categoryTitle": "preferencesModal-module-scss-module__lz7M4G__categoryTitle",
  "categoryTreeLabel": "preferencesModal-module-scss-module__lz7M4G__categoryTreeLabel",
  "categoryTreeView": "preferencesModal-module-scss-module__lz7M4G__categoryTreeView",
  "modalContent": "preferencesModal-module-scss-module__lz7M4G__modalContent",
  "topModal": "preferencesModal-module-scss-module__lz7M4G__topModal",
  "widgetSlugName": "preferencesModal-module-scss-module__lz7M4G__widgetSlugName",
  "widgetToggle": "preferencesModal-module-scss-module__lz7M4G__widgetToggle",
  "widgetsPlaceholderText": "preferencesModal-module-scss-module__lz7M4G__widgetsPlaceholderText",
});
